export const getNameInitials = (name: string) => {
  if (!name) {
    return '';
  }

  const words = name.split(' ').filter((word) => {
    const newWord = word.toLowerCase();
    return newWord !== 'city' && newWord !== 'of';
  });

  if (words.length === 1) {
    return words[0].substring(0, 2).toLocaleUpperCase();
  } else {
    return (words[0].substring(0, 1) + words[1].substring(0, 1)).toUpperCase();
  }
};

export const getFirstName = (name: string) => {
  if (!name) return '';
  const words = name.split(' ');
  return words[0];
};

export const getLastName = (name: string) => {
  if (!name) return '';
  const words = name.split(' ');
  if (words.length === 1) {
    return '';
  }
  return words[1];
};
